import { ShopifyLineItem } from "types";
import { get } from "./";
import { fetchSymbol } from "../fetch/fetch-helper";

const endpoint = '/cart/add';

const getForm = (form: string | FormData | HTMLElement): FormData | null => {
  if (form instanceof FormData) return form;
  if (form instanceof HTMLElement && !(form instanceof HTMLFormElement)) return null;

  let formElement: Element | null = form instanceof HTMLFormElement ? form : document.querySelector(form);
  if (!formElement || !(formElement instanceof HTMLFormElement)) return null;

  return new FormData(formElement);
}

export async function addForm(form: string | FormData | HTMLElement, noIntercept?: boolean): Promise<ShopifyLineItem[]> {
  const formData = getForm(form);
  if (!formData) throw new TypeError(`Couldn't add product from form due to invalid form: ${form}`);
  await window[fetchSymbol].postForm(endpoint, formData, noIntercept);
  const res = await get();
  return res.items;
}
